import { render, staticRenderFns } from "./ChartComparativoVendas.vue?vue&type=template&id=7aea9051"
import script from "./ChartComparativoVendas.vue?vue&type=script&lang=js"
export * from "./ChartComparativoVendas.vue?vue&type=script&lang=js"
import style0 from "./ChartComparativoVendas.vue?vue&type=style&index=0&id=7aea9051&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports